import React, { useEffect, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import { getApiUrl } from "../../utils/apiUrl";
import "./SolicitudComentarios.css";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }

  return "";
}

function SolicitudComentarios({ rut, initialValue = "", onSaved }) {
  const [comentarios, setComentarios] = useState(initialValue || "");
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    setComentarios(initialValue || "");
    setIsEditing(false);
    setFeedback(null);
  }, [initialValue, rut]);

  const handleCancel = () => {
    setComentarios(initialValue || "");
    setIsEditing(false);
    setFeedback(null);
  };

  const handleSave = async () => {
    setIsSaving(true);
    setFeedback(null);

    try {
      const csrfToken = getCookie("csrftoken");

      const response = await fetch(
        getApiUrl(`api/formularios/comunidades/${rut}/comentarios/`),
        {
          method: "PATCH",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          body: JSON.stringify({
            estado: comentarios,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || data.message || "No se pudo guardar.");
      }

      setIsEditing(false);

      setFeedback({
        type: "success",
        message: data.message || "Comentarios guardados correctamente.",
      });

      if (onSaved) {
        onSaved(data.estado);
      }
    } catch (error) {
      setFeedback({
        type: "danger",
        message: error.message || "No se pudo guardar.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="solicitudes-comentarios-card">
      <div className="solicitudes-comentarios-header">
        <div>
          <h6>Comentarios de entrevista</h6>
          <p>
            {isEditing
              ? "Edita las observaciones y guarda los cambios."
              : "Revisa las observaciones registradas para esta solicitud."}
          </p>
        </div>

        <div className="solicitudes-comentarios-actions">
          {!isEditing && (
            <Button
              size="sm"
              variant="outline-dark"
              onClick={() => setIsEditing(true)}
            >
              Editar
            </Button>
          )}

          {isEditing && (
            <>
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={handleCancel}
                disabled={isSaving}
              >
                Cancelar
              </Button>

              <Button
                size="sm"
                variant="dark"
                onClick={handleSave}
                disabled={isSaving}
              >
                {isSaving ? <Spinner animation="border" size="sm" /> : "Guardar"}
              </Button>
            </>
          )}
        </div>
      </div>

      {feedback && (
        <Alert variant={feedback.type} className="solicitudes-comentarios-alert">
          {feedback.message}
        </Alert>
      )}

      <textarea
        className="solicitudes-comentarios-textarea"
        value={comentarios}
        onChange={(event) => setComentarios(event.target.value)}
        disabled={!isEditing || isSaving}
        placeholder="Escribe aquí comentarios, acuerdos, dudas, disponibilidad, impresión general, próximos pasos..."
      />
    </div>
  );
}

export default SolicitudComentarios;
